import apiClient from '../client';
import type {
  ApiResponse,
  CreateCheckoutSessionRequest,
  CreateCheckoutSessionResponse,
  GetPurchaseRequest,
  PurchaseDetails,
} from '../types';

/**
 * Create a new Stripe checkout session
 */
export const createCheckoutSession = async (
  data: CreateCheckoutSessionRequest
): Promise<CreateCheckoutSessionResponse> => {
  const response = await apiClient.post<ApiResponse<CreateCheckoutSessionResponse>>(
    '/checkoutv2/create-checkout-session',
    data
  );

  if (response.data.status === 'error' || !response.data.data) {
    throw new Error(response.data.message || 'Failed to create checkout session');
  }

  return response.data.data;
};

/**
 * Get purchase details by session ID
 */
export const getPurchaseDetails = async (
  data: GetPurchaseRequest
): Promise<PurchaseDetails> => {
  const response = await apiClient.post<ApiResponse<PurchaseDetails>>(
    '/checkoutv2/purchases',
    data
  );

  if (response.data.status === 'error' || !response.data.data) {
    throw new Error(response.data.message || 'Failed to fetch purchase details');
  }

  return response.data.data;
};
